import { Download } from 'lucide-react';
import { useState } from 'react';
import { TagPicker } from 'rsuite';
import { Button } from '../../components/Button';
import { DateRangePickerInput } from '../../components/Input/DateRangePickerInput';
import { useActivityTypeChoices } from '../../hooks/useActivityTypeChoices';
import { ExportPatientDataModal } from './ExportPatientDataModal';

export interface OrgDashboardToolbarProps {
  activityTypeIds: string[];
  dateRange: [Date, Date] | null;
  onActivityTypeIdsChange: (ids: string[]) => void;
  onDateRangeChange: (dateRange: [Date, Date] | null) => void;
}

export function OrgDashboardToolbar({
  activityTypeIds,
  dateRange,
  onActivityTypeIdsChange,
  onDateRangeChange
}: OrgDashboardToolbarProps) {
  const [showExportModal, setShowExportModal] = useState(false);
  const activityTypeChoices = useActivityTypeChoices();

  return (
    <>
      <div className="flex flex-col gap-4 md:flex-row md:gap-0">
        <Button
          size="m"
          iconSize="m"
          icon={Download}
          onClick={() => setShowExportModal(true)}
          data-testid="export-data-button"
        >
          Export Data
        </Button>

        <TagPicker
          data={activityTypeChoices}
          value={activityTypeIds}
          onChange={onActivityTypeIdsChange}
          placeholder="All activities"
          size="lg"
          searchable={false}
          className="md:mx-4 md:w-[350px]"
          data-testid="activity-type-input"
        />

        <DateRangePickerInput
          value={dateRange}
          onChange={onDateRangeChange}
          className="w-[350px]"
          testId="date-range-input"
        />
      </div>
      <ExportPatientDataModal open={showExportModal} onOpenChange={setShowExportModal} />
    </>
  );
}
